module.exports = __webpack_public_path__ + "img/sub_text.415060e7.png";